<!-- 选择多个物料 -->
<template>
  <div>
    <el-dialog
      title="选择物料"
      width="1400px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          v-bind="tableOptions"
          @current-change="tableCurrentChange"
          @keydown="tableKeydown"
        >
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>
          <!-- slot_default -->
          <template #default_dan_wei="{ row }">
            {{ $tool.getDanWei(row.dan_wei) }}
          </template>
          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,

      timer: null,
      filterData: {},

      headerFilterUrl: '/admin/gcvip/products/searchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 320,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          { type: 'checkbox', width: 40 },
          { field: 'category1', title: '一级类目', slots: { header: 'header_input' } },
          { field: 'category2', title: '二级类目', slots: { header: 'header_input' } },
          { field: 'category3', title: '三级类目', slots: { header: 'header_input' } },
          { field: 'category4', title: '四级类目', slots: { header: 'header_input' } },
          { field: 'shang_pin_ming_cheng', title: '商品名称', slots: { header: 'header_input' } },
          {
            field: 'shang_pin_guan_jian_ci',
            title: '商品关键词',
            slots: { header: 'header_input' }
          },
          { field: 'id', title: '商品编码', slots: { header: 'header_input' } },
          { field: 'gui_ge_shi_li', title: '规格', slots: { header: 'header_input' } },
          {
            field: 'dan_wei',
            title: '单位',
            slots: { default: 'default_dan_wei', header: 'header_input' }
          },
          { field: 'dan_jian_shu_liang', title: '单件数量', slots: { header: 'header_input' } },
          { field: 'dan_jia', title: '单价(元)', slots: { header: 'header_input' } },
          { field: 'dan_jian_jin_e', title: '单件金额(元)', slots: { header: 'header_input' } }
        ],
        data: []
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    // 监听-商品筛选数据
    filterData: {
      handler(val) {
        if (val) {
          if (this.timer) clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.getListData()
            this.timer = null
          }, 600)
        }
      },
      deep: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索商品列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取商品列表数据
    getListData() {
      this.tableOptions.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/products/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          filterData: this.filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 获取-当前复选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let rows = this.getCheckboxRecords()
      if (!rows) {
        this.itemChoosePrompt()
        return
      }

      this.popupCancel()
      this.$emit('success', this.$util.deepCopy(rows))
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
